module.exports = __webpack_public_path__ + "img/works_ssFire_btm_off.2170707e.jpg";